import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';

class AlertModal extends Component {
  render() {
    const branding_btn = this.props.locationSettings.btn_outline_enable === 1 ? 'branding-btn-outline' : 'branding-btn';
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.showModal}
          toggle={this.props.toggleModal}
          className="modal sub-modal-a"
        >
          <div className="modal-header no-border primary-color">
            <h5 className="modal-title">&nbsp;</h5>
          </div>
          <ModalBody className="overflow-hidden primary-color">
            <div className="card flex-md-row box-shadow h-100 p-3 no-border primary-color">
              <div className="row row-width">
                <div className="col-lg-12 order-types " id="order_type_id">
                  <div className="ps-3 pe-3" id="order_time">
                    <div className="time-field mb-3">
                      <div className="f1 text-center">
                        <span className="ps-2 primary-font-color">{this.props.msg}</span>
                      </div>
                      <br></br>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter className="no-border primary-color">
            <div className="container-fluid">
              <div className="row">
                <Button
                  className={`col-lg-12 btn btn-primary btn-lg ${branding_btn}`}
                  onClick={this.props.deleteLocation}
                >
                  Delete
                </Button>
                <Button
                  className={`col-lg-12 btn btn-primary btn-lg bg-light no-border text-dark mt-2 ${branding_btn}`}
                  onClick={this.props.toggleModal}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

export default AlertModal;
